function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-image/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 600
// module chunks = 154382131621592